import removeSpecialChars from "@mobi/utils/formatters/removeSpecialChars"

import * as format from "."

export const sendFormatters = {
	cpf: ({ value }) => removeSpecialChars(value),
	cnpj: ({ value }) => removeSpecialChars(value),
	date: ({ value }) => format.toIsoDate(value),
	phone: ({ value }) => removeSpecialChars(format.removeWhiteSpaces(value)),
	month: ({ value }) => format.yearsToMonths(value),
	quantity: ({ value }) => format.quantity(value),
	bool: ({ value }) => format.yesNoToBool(value),
	cep: ({ value }) => removeSpecialChars(value),
	currency: ({ value }) => format.currencyToFloat(value),
	text: ({ value }) => format.sanitizeText(value),
	select: ({ value, options }) => format.selectLabelToValue(value, options)
}

export const fetchFormatters = {
	cpf: ({ value }) => format.toCpf(value),
	cnpj: ({ value }) => format.toCnpj(value),
	date: ({ value }) => format.toDate(value),
	phone: ({ value }) => format.toPhone(value),
	bool: ({ value, accents }) => format.boolToYesNo(value, accents),
	cep: ({ value }) => format.toPostalCode(value),
	displayableNumber: ({ value }) => format.floatToDisplayableNumber(value),
	year: ({ value }) => format.monthsToYears(value),
	select: ({ value, options }) => format.selectValueToLabel(value, options),
	ariaSelect: ({ value, options }) => format.selectValueToLabel(value, options)
}
